const handleFocusTrap = (source, targetClass) => {
    let targetElement;

    targetElement = document.querySelector('.' + targetClass);

    if (!targetElement) {
        targetElement = document.querySelector('#' + targetClass);
    }

    if (!targetElement) {
        console.warn('Target element not found: ' + targetClass);
        return;
    }

    const parentElement = targetElement.closest('.wiacc-parent');
    const isSubmenu = targetClass.includes('submenu');

    if (parentElement) {
        const getFocusableElements = () => {
            const selector = isSubmenu
                ? 'a[href]:not([disabled])'
                : 'button:not([disabled]), [href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])';

            const elements = parentElement.querySelectorAll(selector);

            return Array.from(elements).filter(element => {
                const style = window.getComputedStyle(element);
                return style.display !== 'none' && style.visibility !== 'hidden';
            });
        };

        const getAllFocusableElements = () => {
            const selector = 'button:not([disabled]), [href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])';
            const elements = document.querySelectorAll(selector);
            return Array.from(elements).filter(element => {
                const style = window.getComputedStyle(element);
                return style.display !== 'none' && style.visibility !== 'hidden';
            });
        };

        const wiaccButton = parentElement.querySelector('.wiacc-button:not([disabled])');
        if (wiaccButton) {
            wiaccButton.focus();
              console.log('1. ' + wiaccButton);
        } else {
            const elements = getFocusableElements();
            if (elements.length > 0) {
                if (elements[0].classList.contains('wiacc-close') && elements.length > 1) {
                    const nextElement = elements[1];
                    nextElement.focus();
                         console.log("2: " + nextElement);
                } else {
                    const firstElement = elements[0];
                    firstElement.focus();
                       console.log("3: " + firstElement);
                }
            } else {
                const wiaccClose = parentElement.querySelector('.wiacc-close:not([disabled])');
                if (wiaccClose) {
                    wiaccClose.focus();
                }
            }
        }

        const handleKeyNavigation = (e) => {
            if (isSubmenu) {
                if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                    const focusableElements = getFocusableElements();

                    if (focusableElements.length === 0) return;

                    const currentIndex = focusableElements.indexOf(document.activeElement);

                    if (e.key === 'ArrowDown' && currentIndex === focusableElements.length - 1) {
                        e.preventDefault();
                        const allElements = getAllFocusableElements();
                        const currentGlobalIndex = allElements.indexOf(document.activeElement);
                        if (currentGlobalIndex < allElements.length - 1) {
                            allElements[currentGlobalIndex + 1].focus();
                        }
                        return;
                    }

                    if (e.key === 'ArrowUp' && currentIndex === 0) {
                        e.preventDefault();
                        const allElements = getAllFocusableElements();
                        const currentGlobalIndex = allElements.indexOf(document.activeElement);
                        if (currentGlobalIndex > 0) {
                            allElements[currentGlobalIndex - 1].focus();
                        }
                        return;
                    }

                    e.preventDefault();
                    const nextIndex = e.key === 'ArrowDown' ? currentIndex + 1 : currentIndex - 1;
                    focusableElements[nextIndex].focus();
                }
                return;
            }

            if (e.key !== 'Tab') return;

            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;

            if (!parentElement.contains(document.activeElement)) {
                e.preventDefault();
                focusableElements[0].focus();
                return;
            }

            const firstFocusableElement = focusableElements[0];
            const lastFocusableElement = focusableElements[focusableElements.length - 1];

            if (e.shiftKey && document.activeElement === firstFocusableElement) {
                e.preventDefault();
                lastFocusableElement.focus();
            } else if (!e.shiftKey && document.activeElement === lastFocusableElement) {
                e.preventDefault();
                firstFocusableElement.focus();
            }
        };

        parentElement.addEventListener('keydown', handleKeyNavigation);

        return () => {
            parentElement.removeEventListener('keydown', handleKeyNavigation);
        };
    } else {
        console.log('A target osztályú elem NEM rendelkezik wiacc-parent osztállyal');
    }
};